import ShieldStar from '~components/svgs/ShieldStar';
import { Props } from './types';
import * as Styled from './styled';

const ScreenWarning = ({ message, className }: Props) => {
  const Wrapper = typeof message === 'string' ? Styled.Container : Styled.Wrap;

  return (
    <Styled.Main className={className}>
      <ShieldStar />
      <Wrapper>
        {typeof message === 'string' ? (
          <Styled.Text>{message}</Styled.Text>
        ) : (
          <Styled.List>
            {message.map((x: string) => {
              return <Styled.Item key={x}>{x}</Styled.Item>;
            })}
          </Styled.List>
        )}
      </Wrapper>
    </Styled.Main>
  );
};

export default ScreenWarning;
